{
  "approve": "Freigeben",
  "emailConfirmed": "E-Mail bestätigt",
  "emailNotConfirmed": "E-Mail nicht bestätigt",
  "registeredAt": "registriert {{time}}",
  "reject": "Ablehnen"
}
